import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class SectionSocialProof {

	constructor(dom) {

		// Vars
		// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
		this.NAME = `SectionSocialProof`;

		this.isScrolling = false;

		this.dom = dom;
		this.domActiveClass = `section-social-proof--active`;
		this.scrollerDom = this.dom.querySelector(`[data-section-social-proof-scroller]`);
		this.logosGroupDom = this.dom.querySelector(`[data-section-social-proof-logos]`);

		this.resizeTimeout;
		this.scrollInterval;
		this.scrollSpeed = this.dom.getAttribute(`data-section-social-proof-scroller-speed`) || 8000;
		this.scrollDistance = 0;

	}

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	init() {
		Logger.info(`${this.NAME} > init`);

		const self = this;

		// Measure the logos
		setTimeout(() => {
			this.measureLogos();
			window.addEventListener('resize', (e) => {
				self.hide();
				clearTimeout(this.resizeTimeout);
				this.resizeTimeout = setTimeout(() => {
					self.measureLogos();
					self.start();
					setTimeout(self.show.bind(self), 2000);
				}, 500);
			});
		}, 1000);

		/**
		* Initialize the marquee when visible
		*/
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const intersecting = entry.isIntersecting;

				if (intersecting && !this.isScrolling) {
					setTimeout(() => {
						self.start();
					}, 1000);
				} else if (!intersecting && this.isScrolling) {
					self.stopScrolling();
				}
			})
		})

		observer.observe(this.dom);
	}

	hide() {
		Logger.info(`${this.NAME} > hide`);
		this.dom.classList.remove(this.domActiveClass);
	}

	/**
	 * Measure the width of the logos group
	 */
	measureLogos() {
		Logger.info(`${this.NAME} > measureLogos`);

		if (!this.logosGroupDom) {
			return;
		}

		// Measure the width of the logos group
		const logosGroupWidth = this.logosGroupDom.offsetWidth;
		if (logosGroupWidth < 1) {
			return;
		}

		// Measure the width of the parent container
		const parentWidth = this.dom.offsetWidth;

		// Get the minimum number of logo groups needed to fill the parent
		// We need at least 2 copies for seamless scrolling (multiply by 2)
		const minimumGroups = Math.ceil(parentWidth / logosGroupWidth) * 2;

		// Remove all duplicate logo groups except for the first one
		const allGroups = this.scrollerDom.querySelectorAll(`[data-section-social-proof-logos]`);
		allGroups.forEach((group, i) => {
			if (i === 0) return;
			group.remove();
		});

		// Clone and append logo groups to create seamless scrolling
		for (let i = 0; i < minimumGroups; i++) {
			const clonedGroup = this.logosGroupDom.cloneNode(true);
			clonedGroup.setAttribute('data-section-social-proof-logos', '');
			this.scrollerDom.appendChild(clonedGroup);
		}

		// Calculate scroll distance (half of total width for seamless loop)
		this.scrollDistance = (minimumGroups * logosGroupWidth) / 2;

		this.reset();
	}

	/**
	 * Reset
	 */
	reset() {
		Logger.info(`${this.NAME} > reset`);

		// Reset
		this.scrollerDom.style.transition = `none`;
		this.scrollerDom.style.transform = `translateX(0px)`;
	}

	/**
	 * Show the marquee
	 */
	show() {
		Logger.info(`${this.NAME} > show`);
		this.dom.classList.add(this.domActiveClass);
	}

	/**
	 * Scroll the scroll dom
	 */
	scroll() {
		Logger.info(`${this.NAME} > scroll`);

		this.reset();

		// Scroll
		setTimeout(() => {
			this.scrollerDom.style.transition = `${this.scrollSpeed / 1000}s transform linear`;
			this.scrollerDom.style.transform = `translateX(-${this.scrollDistance}px)`;
			this.show();
			this.isScrolling = true;
		}, 20);
	}

	start() {
		Logger.info(`${this.NAME} > start`);
		clearInterval(this.scrollInterval);
		this.scroll();
		this.scrollInterval = setInterval(this.scroll.bind(this), this.scrollSpeed);
	}

	/**
	 * Stop all scrolling
	 */
	stopScrolling() {
		Logger.info(`${this.NAME} > stopScrolling`);
		clearInterval(this.scrollInterval);
		this.hide();
		this.reset();
		this.isScrolling = false;
	}

}

// Mixins
Object.assign(SectionSocialProof.prototype, eventMixin);

